import script from "./LocationalCert.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationalCert.vue?vue&type=script&setup=true&lang=js"

import "./LocationalCert.vue?vue&type=style&index=0&id=3ae0fb12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae0fb12"]])

export default __exports__